import React from 'react';
import {connect} from 'react-redux';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';
import actions from './actions';

const mapStateToProps = (state) => {
    return {
        activeSavesCount: state.autoSave.activeSavesCount
    };
};

const mapDispatchToProps = dispatch => ({
    beginSave: () => dispatch(actions.incrementActiveSaves()),
    onSuccess: () => dispatch(actions.decrementActiveSaves()),
    onFailure: () => dispatch(actions.incrementFailedSaves()),
});

export default connect(mapStateToProps, mapDispatchToProps)(
    class AutoSave extends React.Component {
        constructor(props) {
            super(props);
            this.debouncedSave = debounce(() => this.props.onAutoSave(this.props.watch, this.props.onSuccess, this.props.onFailure), 200);
        }

        shouldComponentUpdate(nextProps) {
            return !(!nextProps.activeSavesCount && (!this.props.watch || isEqual(nextProps.watch, this.props.watch)));
        }

        componentDidUpdate(prevProps) {
            setTimeout(() => {
                if (!this.props.activeSavesCount && !isEqual(this.props.watch, prevProps.watch)) {
                    this.props.beginSave();
                } else if (this.props.activeSavesCount > 0) {
                    this.debouncedSave();
                }
            }, 0);
        }

        render() {
            return this.props.children;
        }
    }
);
